import React from "react";
import Typography from "../Typography";

interface InputRangeProps {
    label: string;
    min: number;
    max: number;
    value: number;
    unit?: "руб" | "лет" | string;
    onChange: (value: number) => void;
}

export const InputRange: React.FC<InputRangeProps> = ({
    label,
    min,
    max,
    value,
    unit = "",
    onChange,
}) => {
    const formatValue = (val: number) => {
        if (unit === "руб") return `${val.toLocaleString("ru-RU")} ₽`;
        if (unit === "лет") return `${val} лет`;
        return `${val} ${unit}`.trim();
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(Number(e.target.value));
    };

    const progressPercentage = ((value - min) / (max - min)) * 100;

    return (
        <div className="w-full flex flex-col gap-[16px] md:gap-[20px] lg:gap-[24px]">
            <Typography className="text-[14px] md:text-[16px] font-medium">
                {label}
            </Typography>

            <div className="w-full flex flex-col gap-[8px] md:gap-[12px]">
                <Typography className="text-[16px]">
                    {formatValue(value)}
                </Typography>

                <input
                    type="range"
                    min={min}
                    max={max}
                    value={value}
                    onChange={handleInputChange}
                    style={{
                        background: `linear-gradient(to right, #0F1C37B2 0%, #0F1C37B2 ${progressPercentage}%, #e5e7eb ${progressPercentage}%, #e5e7eb 100%)`,
                    }}
                    className="
                        w-full h-[5px] rounded-lg appearance-none cursor-pointer dark:bg-black-50

                        [&::-webkit-slider-thumb]:appearance-none
                        [&::-webkit-slider-thumb]:h-[15px]
                        [&::-webkit-slider-thumb]:w-[15px]
                        [&::-webkit-slider-thumb]:rounded-full
                        [&::-webkit-slider-thumb]:bg-main-grey
                        [&::-webkit-slider-thumb]:ring-1
                        [&::-webkit-slider-thumb]:ring-[#0F1C37B2]
                        [&::-webkit-slider-thumb]:ring-offset-0

                        [&::-moz-range-thumb]:h-[15px]
                        [&::-moz-range-thumb]:w-[15px]
                        [&::-moz-range-thumb]:rounded-full
                        [&::-moz-range-thumb]:bg-main-grey
                        [&::-moz-range-thumb]:box-border
                        [&::-moz-range-thumb]:border
                        [&::-moz-range-thumb]:border-[#0F1C37B2]
                    "
                />
                <div className="flex justify-between text-xs text-gray-500 mb-1">
                    <Typography className="text-[12px] md:text-[12px] font-medium text-blue-70">
                        {formatValue(min)}
                    </Typography>
                    <Typography className="text-[12px] md:text-[12px] font-medium text-blue-70">
                        {formatValue(max)}
                    </Typography>
                </div>
            </div>
        </div>
    );
};
